import LineChartSingleSeries from './LineChartSingleSeries.json';
import LineChartSingleSeriesCompact from './LineChartSingleSeriesCompact.json';
import AreaChartSingleSeries from './AreaChartSingleSeries.json';
import AreaChartSingleSeriesCompact from './AreaChartSingleSeriesCompact.json';

export default [
  LineChartSingleSeries,
  AreaChartSingleSeries,
  LineChartSingleSeriesCompact,
  AreaChartSingleSeriesCompact,
];
